'use client';

import { Button } from '@kit/ui/button';
import { Trans } from '@kit/ui/trans';

/**
 * Der Rücksprung auf der 404 — Blatt P7.
 *
 * 🔴 NUR SCHRIFT, KEIN ZWEITER VOLLKNOPF. P7 verbindlich: „Hauptknopf indigo
 * 44 px, zweite Aktion nur Schrift." Hier stand ein zweiter Vollknopf mit
 * Pfeil-Symbol; zwei gleich starke Knöpfe nebeneinander lassen die Wahl offen,
 * wo eine gemeint ist — der Weg zur Startseite ist der Vorschlag, „Zurück" die
 * Nebentür.
 *
 * 🔴 Und die Aufschrift heisst „Zurück", nicht „Vermietungen": „auf einer
 * Marketing-Seite gibt es die nicht." Dieselbe Regel, aus der die 404 ihren
 * ganzen Text bezieht — sie darf nichts über den Ort behaupten.
 *
 * ⚠️ Das Pfeil-Symbol ist mit dem Vollknopf gefallen. Es zeigte in eine
 * Richtung, die `history.back()` nur ungefähr einhält: wer über einen Verweis
 * von aussen kommt, hat keine Vorgeschichte in dieser Anwendung, und der Pfeil
 * versprach dann einen Weg, den es nicht gab.
 */
export function BackButton() {
  return (
    <Button variant="ghost" onClick={() => history.back()}>
      <Trans i18nKey="common:p7Zurueck" />
    </Button>
  );
}
